(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bdl-disc-quiz"] && !Shopify.designMode) return;
  try {
    
/* Deterministic editorial starting points, not a predictive fitting model.
   Flight values are audited catalog numbers; no plastic or weight inference. */
function quizProfile(a) {
  const beginner = a.experience === 'new' || ['unsure', 'short'].includes(a.distance);
  const shape = a.goal === 'putt' && a.shape === 'turn' ? 'straight' : a.shape;
  // Job first: a basket putt, placement approach, learning disc and tee shot
  // should not collapse into the same putter target just because someone is new.
  let group, target, minSpeed, maxSpeed;
  if (a.goal === 'putt') {
    group = 'putter'; target = [2, 3, 0, 1]; minSpeed = 1; maxSpeed = 3;
  } else if (a.goal === 'approach') {
    group = 'putter'; target = [3, 3, 0, 1]; minSpeed = 1; maxSpeed = 4;
  } else if (a.goal === 'allround') {
    group = 'mid'; target = beginner ? [4, 4, -1, 1] : [5, 5, -0.5, 1]; minSpeed = 1; maxSpeed = 5;
  } else {
    const fairway = !beginner && a.experience === 'confident' && a.distance === 'long';
    group = fairway ? 'fairway' : 'mid';
    target = fairway ? [7, 5, -1, 1] : [5, 5, -1, 1]; minSpeed = 3; maxSpeed = fairway ? 7 : 5;
  }
  if (shape === 'turn') { target[2] = beginner ? -1.5 : -2; target[3] = 1; }
  if (shape === 'finish') { target[2] = 0; target[3] = 2; }
  if (shape === 'lowcarry') {
    target[1] = ['putt', 'approach'].includes(a.goal) ? 2 : 3;
    target[2] = 0; target[3] = 2;
    if (a.goal === 'approach') target[0] = 2;
  }
  const reason = a.goal === 'putt' ? 'putt' : a.goal === 'approach' ? 'approach' : a.goal === 'allround' ? 'learning_disc' : group === 'fairway' ? 'fairway' : 'tee_mid';
  return { group, reason, shape, target, minSpeed, maxSpeed, beginner };
}
function quizMoldKey(p) {
  // Display-only identities audited against explicit current product titles and
  // maker descriptions. Not a candidate pool. New or renamed products stay
  // separate rather than guessing a mold from a similar name (e.g. Chief OS).
  const editions = {"axiom-crave":["axiom-crave","Axiom Crave| 6.5/5/-1/1"],"6-5-1-1-axiom-crave-fission":["axiom-crave","6.5/5/-1/1  | Axiom Crave | Fission Plastic"],"axiom-crave-plasma":["axiom-crave","6.5/5/-1/1 Axiom Crave - Plasma"],"trashpanda-canyon":["trashpanda-canyon","Trash Panda Canyon | 4/3/0/2"],"trash-panda-rubber-ducky-canyon":["trashpanda-canyon","4 | 3 | 0 | 2 Trash Panda Rubber Ducky Canyon"],"gateway-wizardssss":["gateway-wizard","Gateway Wizard SSSS | 2/3/0/2"],"gateway-wizardsss":["gateway-wizard","Gateway Wizard SSS | 2/3/0/2"],"gateway-wizard-lunar-placeholder":["gateway-wizard","Gateway Wizard | 2/3/0/2 | Lunar"],"latitude64-pure":["latitude64-pure","Latitude 64 / Pure / Blue / Zero Medium | 3/3/-1/1"],"latitude-64-pure-multi-plastic":["latitude64-pure","3/3/-1/1 Latitude 64 Pure"],"discraft-joy-z-sparkle-mid-range":["discraft-joy","DiscCraft Discraft / Joy/ Z-Sparkle/ | 4/5/-1/1"],"discraft-limited-edition-prototype-paige-pierce-signature-esp-joy-midrange":["discraft-joy","Discraft Limited Edition Joy | Esp | 4/5/-1/1"],"innova-halo-star-leopard3-fairway-driver":["innova-leopard3","Innova Leopard3 | Halo Star | 7/5/-2/1"],"innova-leopard3-duo-fairway-7-5-2-1":["innova-leopard3","Innova | Leopard3| Duo | Fairway| 7/5/-2/1"],"axiom-neutron-soft-hex-midrange":["axiom-hex","Axiom Discs Hex Neutron Soft | 5/5/-1/1"],"axiom-neutron-hex-midrange":["axiom-hex","Axiom Discs Hex Neutron | 5/5/-1/1"],"axiom-hex-plasma":["axiom-hex","5/5/-1/1 Axiom Hex - Plasma"],"axiom-hex-total-eclipse":["axiom-hex","5/5/-1/1 Axiom Hex Total Eclipse"],"gateway-chief-lunar-placeholder":["gateway-chief","Gateway Chief | 3/3/0/1 | Lunar"],"gateway-chief-rock-hard-lunar":["gateway-chief","3 | 3 | 0 | 1 | Rock Hard Chief | Lunar"]};
  const edition = editions[p.handle];
  return edition && p.title === edition[1] ? edition[0] : 'product:' + p.handle;
}
function rankQuizCandidates(candidates, a) {
  const profile = quizProfile(a);
  const ranked = candidates.filter(p => p.available !== false && p.handle !== 'gateway-training-wizard' && p.flight[0] >= profile.minSpeed && p.flight[0] <= profile.maxSpeed && p.flight[3] <= 2 && p.flight[2] >= (profile.shape === 'turn' ? -3 : -2) && (profile.shape !== 'lowcarry' || p.flight[1] <= 3) && (profile.shape !== 'finish' || p.flight[3] >= 1.5) && (profile.shape !== 'turn' || p.flight[2] < 0) && (!['straight', 'turn'].includes(profile.shape) || p.flight[3] <= 1.5)).map(p => {
    let score = p.flight.reduce((sum, n, i) => sum + Math.abs(n - profile.target[i]) * [4, 2, 3, 3][i], 0);
    if (a.goal === 'putt' && !/\bputting\b|\bputts\b/i.test(p.description || '')) score += 3;
    return { ...p, score };
  }).sort((a, b) => a.score - b.score || a.handle.localeCompare(b.handle));
  // Absolute fit limit prevents a poor fallback when stock is sparse. Matching
  // flight numbers do not make different molds/plastics invalid alternatives.
  const matches = ranked.filter(p => p.score <= 12 && p.score <= ranked[0].score + 6);
  const picks = [], seenMolds = new Set();
  for (const p of matches) {
    const key = quizMoldKey(p);
    if (!seenMolds.has(key)) { picks.push(p); seenMolds.add(key); }
    if (picks.length === 3) break;
  }
  return { ...profile, picks, matches };
}

function quizCatalogUrl(value, previewThemeId) {
  const url = new URL(value, location.origin);
  const preview = previewThemeId || new URLSearchParams(location.search).get('preview_theme_id');
  if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
  return url;
}
async function readQuizPayload(response, kind, requestedUrl) {
  if (!response.ok) {
    const error = new Error(kind + '_request_' + response.status);
    const endpoint = new URL(requestedUrl, location.origin);
    // Show only the public path and page, never preview tokens or other query data.
    error.quizEndpoint = endpoint.pathname.slice(0, 160) + ' (page ' + (endpoint.searchParams.get('page') || '1').replace(/[^0-9]/g, '').slice(0, 6) + ')';
    throw error;
  }
  const text = await response.text();
  const begin = '<!--BDL_QUIZ_DATA_START-->', end = '<!--BDL_QUIZ_DATA_END-->';
  const first = text.indexOf(begin), last = text.lastIndexOf(end);
  const payload = first >= 0 && last > first ? text.slice(first + begin.length, last) : text;
  try { return JSON.parse(payload); }
  catch (_) { throw new Error(kind + (/<(?:!doctype|html|body|script|div|form)\b/i.test(text) ? '_html_response' : '_invalid_json')); }
}
/* Read only public catalog fields. Conflicting or absent ratings never get guessed. */
function flightTuples(text) {
  const normalized = String(text || '').replace(/[−–—]/g, '-').replace(/<[^>]*>/g, ' ');
  const number = '-?\\d+(?:\\.\\d+)?';
  const pattern = new RegExp('(?<![\\d.−-])(?=(' + number + ')\\s*([/|])\\s*(' + number + ')\\s*\\2\\s*(' + number + ')\\s*\\2\\s*(' + number + ')(?![\\d.]))', 'g');
  return Array.from(normalized.matchAll(pattern), m => [m[1],m[3],m[4],m[5]].map(Number));
}
function catalogCandidate(p) {
  if (/mobile/i.test(p.title) || /mobile/i.test((p.tags || []).join(' '))) return { excluded: 'mobile_only' };
  if (!p.available) return { excluded: 'unavailable' };
  if (!Array.isArray(p.variants) || !p.variants.some(v => v.available && v.inStock && v.tracked && v.policy === 'deny')) return { excluded: 'no_confirmed_stock' };
  if (/\bish\b/i.test(p.title) || /official flight numbers.*(?:not|haven.t|unreleased)|flight numbers.*(?:speculat|unconfirmed|unknown)|or maybe it is/i.test(p.description)) return { excluded: 'unverified_flight' };
  if (/mini|marker|accessor|apparel|shirt|hoodie|towel|sticker|bag|backpack|basket|bundle|set\b|mystery|retriever|charger|flashlight|lighting|footbag|book|hat\b|jersey|ultimate|catch disc|sac\b|grip enhancer|tape/i.test(p.type || '') || /\bmini\b|\bmarker\b|\b3[- ]disc\b|\bset\b/i.test(p.title)) return { excluded: 'not_single_disc' };
  if (!p.type && /\bbag\b|\btape\b/i.test(p.title)) return { excluded: 'not_single_disc' };
  const tuples = [...flightTuples(p.title), ...flightTuples(p.description)];
  if (!tuples.length) return { excluded: 'missing_flight' };
  const valid = t => t[0] >= 1 && t[0] <= 15 && t[1] >= 0 && t[1] <= 7 && t[2] >= -5 && t[2] <= 1 && t[3] >= 0 && t[3] <= 6;
  const validTuples = tuples.filter(valid);
  if (!validTuples.length || validTuples.length !== tuples.length) return { excluded: 'conflicting_flight' };
  const unique = new Map(validTuples.map(t => [t.join('/'),t]));
  if (unique.size !== 1) return { excluded: 'conflicting_flight' };
  const flight = validTuples[0];
  // Explicit accessory types and terms prevent matching non-disc products with printed ratings.
  if (/mini|marker|phone case|shirt|hoodie|towel|sticker|bag|basket|bundle|set\b/i.test(p.type || '') || /\bmini\b|\bmarker\b|\b3[- ]disc\b|\bset\b/i.test(p.title)) return { excluded: 'not_single_disc' };
  const group = flight[0] <= 3 ? 'putter' : flight[0] <= 5.5 ? 'mid' : 'fairway';
  return { ...p, flight, group };
}
function prepareQuizCatalog(products) {
  const candidates = [], exclusions = {};
  products.forEach(p => {
    const candidate = catalogCandidate(p);
    if (candidate.excluded) exclusions[candidate.excluded] = (exclusions[candidate.excluded] || 0) + 1;
    else candidates.push(candidate);
  });
  return { candidates, exclusions, total: products.length };
}
async function loadQuizCatalog(startUrl, fetcher, signal) {
  const start = new URL(startUrl, location.origin);
  const seenPages = new Set(), products = new Map();
  let url = start, expectedPage = 1, expectedTotal = null;
  while (url) {
    if (url.origin !== start.origin || url.pathname !== start.pathname || seenPages.has(url.href)) throw new Error('catalog_pagination');
    seenPages.add(url.href);
    const response = await fetcher(url.href, { credentials: 'same-origin', signal, cache: 'no-store', headers: { Accept: 'text/html' } });
    const page = await readQuizPayload(response, 'catalog', url.href);
    if (page.version !== 1 || page.page !== expectedPage || !Array.isArray(page.products) || !Number.isInteger(page.total) || !Number.isInteger(page.pages)) throw new Error('catalog_format');
    if (expectedTotal === null) expectedTotal = page.total;
    if (page.total !== expectedTotal) throw new Error('catalog_changed');
    for (const p of page.products) {
      if (!p || typeof p.handle !== 'string' || typeof p.title !== 'string' || products.has(p.handle)) throw new Error('catalog_duplicates');
      products.set(p.handle, p);
    }
    if (page.complete === true) {
      if (page.next || (page.page !== page.pages && !(expectedTotal === 0 && page.pages === 0 && page.page === 1)) || products.size !== expectedTotal) throw new Error('catalog_incomplete');
      url = null;
    } else {
      if (!page.next || page.page >= page.pages || page.products.length === 0) throw new Error('catalog_incomplete');
      url = new URL(page.next, start);
      url.searchParams.set('view', 'bdl-quiz-catalog');
      if (start.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', start.searchParams.get('preview_theme_id'));
      expectedPage += 1;
    }
  }
  return Array.from(products.values());
}
async function loadQuizVariantPages(product, originUrl, fetcher, signal) {
  const origin = new URL(originUrl, location.origin);
  const start = new URL(product.url, origin);
  if (start.origin !== origin.origin) throw new Error('catalog_product_url');
  start.search = '';
  start.searchParams.set('view', 'bdl-quiz-stock');
  if (origin.searchParams.has('preview_theme_id')) start.searchParams.set('preview_theme_id', origin.searchParams.get('preview_theme_id'));
  let url = start, expectedPage = 1;
  const visited = new Set(), variants = new Map();
  while (url) {
    if (url.origin !== start.origin || url.pathname !== start.pathname || visited.has(url.href)) throw new Error('variant_pagination');
    visited.add(url.href);
    const response = await fetcher(url.href, { credentials: 'same-origin', signal, cache: 'no-store', headers: {Accept: 'text/html'} });
    const page = await readQuizPayload(response, 'variant', url.href);
    if (page.version !== 1 || page.handle !== product.handle || page.page !== expectedPage || page.total !== product.variantCount || !Array.isArray(page.variants)) throw new Error('variant_format');
    page.variants.forEach(v => { if (!v.id || variants.has(v.id)) throw new Error('variant_duplicates'); variants.set(v.id, v); });
    if (page.complete === true) {
      if (page.next || variants.size !== product.variantCount || page.page !== page.pages) throw new Error('variant_incomplete');
      url = null;
    } else {
      if (!page.next || page.page >= page.pages || page.variants.length === 0) throw new Error('variant_incomplete');
      url = new URL(page.next, start);
      url.searchParams.set('view', 'bdl-quiz-stock');
      if (start.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', start.searchParams.get('preview_theme_id'));
      expectedPage += 1;
    }
  }
  return [...variants.values()];
}
async function fetchCompleteQuizCatalog(url, fetcher, signal) {
  const products = await loadQuizCatalog(url, fetcher, signal);
  for (const product of products) {
    if (!Array.isArray(product.variants) || !Number.isInteger(product.variantCount)) throw new Error('variant_metadata');
    if (product.variants.length !== product.variantCount) product.variants = await loadQuizVariantPages(product, url, fetcher, signal);
  }
  return prepareQuizCatalog(products);
}

if (!customElements.get('bdl-disc-quiz')) {
  customElements.define('bdl-disc-quiz', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const form = this.querySelector('form');
      const results = this.querySelector('.bdl-quiz__results');
      const status = this.querySelector('[data-status]');
      const submit = form.querySelector('[type="submit"]');
      const container = this.querySelector('.bdl-quiz__cards');
      const more = this.querySelector('[data-more]');
      const moreCards = this.querySelector('[data-more-cards]');
      const copy = key => this.querySelector('[data-copy="' + key + '"]').textContent;
      const format = (key, values) => Object.entries(values).reduce((s, [k,v]) => s.replaceAll('{' + k + '}', String(v)), copy(key));
      form.hidden = false;
      let request = 0;
      const clear = () => {
        request += 1;
        if (this.quizAbort) this.quizAbort.abort();
        results.hidden = true;
        container.replaceChildren();
        moreCards.replaceChildren();
        more.hidden = true;
        more.open = false;
        status.textContent = '';
        submit.disabled = false;
        form.removeAttribute('aria-busy');
      };
      this.quizClear = clear;
      form.addEventListener('change', clear);
      form.addEventListener('reset', clear);
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        clear();
        const current = request;
        const answers = Object.fromEntries(new FormData(form));
        this.quizAbort = new AbortController();
        status.textContent = copy('loading');
        submit.disabled = true;
        form.setAttribute('aria-busy', 'true');
        try {
          const url = quizCatalogUrl(this.dataset.catalogUrl, this.dataset.previewThemeId);
          const catalog = await fetchCompleteQuizCatalog(url.href, window.fetch.bind(window), this.quizAbort.signal);
          if (request !== current) return;
          const match = rankQuizCandidates(catalog.candidates, answers);
          this.querySelectorAll('[data-title]').forEach(el => { el.hidden = el.dataset.title !== match.group; });
          this.querySelectorAll('[data-reason]').forEach(el => { el.hidden = el.dataset.reason !== match.reason; });
          this.querySelectorAll('[data-shape]').forEach(el => { el.hidden = el.dataset.shape !== match.shape; });
          this.querySelector('[data-putt-turn]').hidden = !(answers.goal === 'putt' && answers.shape === 'turn');
          const firstHandles = new Set(match.picks.map(p => p.handle));
          const extraMatches = match.matches.filter(p => !firstHandles.has(p.handle));
          const displayMatches = [...match.picks, ...extraMatches];
          displayMatches.forEach((p, i) => {
            const fragment = this.querySelector('template[data-card]').content.cloneNode(true);
            const card = fragment.querySelector('article');
            card.querySelector('[data-card-rank]').textContent = copy(i === 0 ? 'primary' : 'alternative');
            card.querySelector('h4').textContent = p.title;
            card.querySelector('[data-card-numbers]').textContent = p.flight.join(' / ');
            card.querySelector('[data-card-price]').textContent = p.price;
            card.querySelector('[data-card-fit]').textContent = format('fit_' + match.shape, { speed: p.flight[0], glide: p.flight[1], turn: p.flight[2], fade: p.flight[3] });
            const editions = match.matches.filter(other => quizMoldKey(other) === quizMoldKey(p)).length;
            if (i < match.picks.length && editions > 1) card.querySelector('[data-card-fit]').textContent += ' ' + format('edition_count', { count: editions - 1 });
            if (answers.goal === 'putt') card.querySelector('[data-card-fit]').textContent += ' ' + copy(/\bputting\b|\bputts\b/i.test(p.description || '') ? 'putting_source' : 'putting_alternative');
            const link = card.querySelector('a');
            const productUrl = new URL(p.url, location.origin);
            if (productUrl.origin !== location.origin) throw new Error('catalog_product_url');
            link.href = productUrl.href;
            const img = card.querySelector('img');
            if (p.image) { img.src = p.image; img.alt = p.title; } else img.remove();
            (i < match.picks.length ? container : moreCards).appendChild(fragment);
          });
          more.hidden = extraMatches.length === 0;
          this.querySelector('[data-more-label]').textContent = format('more_matches', { count: extraMatches.length });
          this.querySelector('[data-empty]').hidden = match.picks.length > 0;
          this.querySelector('[data-few]').hidden = match.picks.length === 0 || match.picks.length >= 3;
          const gaps = (catalog.exclusions.missing_flight || 0) + (catalog.exclusions.conflicting_flight || 0) + (catalog.exclusions.unverified_flight || 0);
          this.querySelector('[data-coverage]').textContent = format('coverage', {total: catalog.total, usable: catalog.candidates.length, gaps, faster: catalog.candidates.filter(p => p.flight[0] > 7).length});
          results.hidden = false;
          status.textContent = format('match_count', { count: match.matches.length });
          results.focus({ preventScroll: true });
          results.scrollIntoView({ behavior: 'auto', block: 'nearest' });
        } catch (error) {
          if (request !== current || error.name === 'AbortError') return;
          container.replaceChildren();
          moreCards.replaceChildren();
          more.hidden = true;
          results.hidden = true;
          const code = /^(catalog|variant)_[a-z_0-9]+$/.test(error.message) ? error.message : error instanceof TypeError ? 'catalog_network' : 'quiz_unexpected';
          status.textContent = copy('failed') + ' [' + code + ']' + (error.quizEndpoint ? ' ' + error.quizEndpoint : '');
        } finally {
          if (request === current) { submit.disabled = false; form.removeAttribute('aria-busy'); }
        }
      });
    }
    disconnectedCallback() { if (this.quizClear) this.quizClear(); }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
